module.exports = __webpack_public_path__ + "static/media/PP006.54bb68d5.jpg";